import React, { Component } from "react";
import { Switch, BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Header from "./components/Header";
import About from "./components/About";
import Resume from "./components/Resume";
import Portfolio from "./components/Portfolio";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import resumeData from "./resumeData";
import portfolioData from "./portfolioData";

import PortfolioDetails from "./portfolioDetails";

class Main extends Component {
  render() {
    return (
      <div className="App">
        <Header resumeData={resumeData} />
        <About resumeData={resumeData} />
        <Resume resumeData={resumeData} />
        <Portfolio resumeData={resumeData} />
        <ContactUs resumeData={resumeData} />
        <Footer resumeData={resumeData} />
      </div>
    );
  }
}

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
        <Route exact path="/" component={Main} />

          {portfolioData.map(pD=>(
            <Route
            key={pD.title}
            path={pD.url}
            render={(props) => <PortfolioDetails data={pD} {...props} /> }
          />))}

          <Redirect to="/" />
        </Switch>
      </Router>
    );
  }
}

export default App;
